import { Controller } from "@hotwired/stimulus";

// 問い合わせの希望内容欄。問い合わせ種別に依存せず再利用する。
export default class extends Controller {
  static targets = ["checkbox", "textarea", "guidance"];

  connect() {
    this.toggle();
  }

  toggle() {
    const noPreferences = this.checkboxTarget.checked;
    const textarea = this.textareaTarget;

    // 値を消さず、チェックを戻したときに入力を再開できるようにする。
    // 同名のチェックボックスから「特に希望はありません」を送信する。
    textarea.disabled = noPreferences;
    textarea.toggleAttribute("data-formrun-required", !noPreferences);
    this.guidanceTarget.classList.toggle("text-muted", noPreferences);

    // formrunにも変更を通知し、表示済みの必須エラーを更新する。
    textarea.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
